import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=31b482d4"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports